import { computed } from 'vue'
import { v4 as uuidv4 } from 'uuid'
import { Categories, CategoriesForm, Dropdown, DropdownForm, Link, LinkForm } from '@/Components/Navigation'

export const createBaseMenuItem = () => ({
  id: uuidv4(),
  parent_id: null,
  name: 'New Item',
  component: null,
  hasIcon: false,
  icon: null,
  hasHref: false,
  href: null,
  switchesTenant: false,
  tenant: null,
  hasChildren: false,
  allowedChildren: [],
  items: [],
  meta: {
    // Note: meta is for component-specific options that do not apply to all
    // components.
  },
  viewport: {
    mobile: {
      order: 0,
      section: null,
      visible: true,
    },
    tablet: {
      order: 0,
      section: null,
      visible: true,
    },
    desktop: {
      order: 0,
      section: 'left',
      visible: true,
    }
  },
})

export const createLink = () => {
  return {
    ...createBaseMenuItem(),
    component: 'Link',
    hasIcon: true,
    hasHref: true,
    hasChildren: false,
  }
}

export const createDropdown = () => {
  return {
    ...createBaseMenuItem(),
    component: 'Dropdown',
    hasIcon: true,
    hasHref: true,
    hasChildren: true,
    allowedChildren: ['Link', 'Dropdown'],
  }
}

export const createCategories = () => {
  return {
    ...createBaseMenuItem(),
    component: 'Categories',
    name: 'Categories',
  }
}

export const componentMap = computed(() => ({
  'Link': Link,
  'Dropdown': Dropdown,
  'Categories' : Categories,
}))

export const componentFormMap = computed(() => ({
  'Link': LinkForm,
  'Dropdown': DropdownForm,
  'Categories': CategoriesForm,
}))
